/* eslint-disable max-len */

import React from 'react';

const ArrowIcon = () => (
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.00004 3.52755L8.35229 0.175293L9.14779 0.970788L5.00004 5.11854L0.852295 0.970788L1.64779 0.175293L5.00004 3.52755Z" fill="#009EE3" />
    <path d="M5.00004 3.52755L8.35229 0.175293L9.14779 0.970788L5.00004 5.11854L0.852295 0.970788L1.64779 0.175293L5.00004 3.52755Z" fill="#009EE3" />
  </svg>
);

export default ArrowIcon;
